<div class="main-menu-wrapper w-full h-full" [attr.data-test-id]="'left-menu'">
  <nav id="main-menu" class="main-menu" i18n-aria-label aria-label="Main" tabindex="-1" (keyup.esc)="onHideMainMenu()">
    <thehubz-menu-items [menuItemList]="menuItemList" (hideMainMenu)="onHideMainMenu()"></thehubz-menu-items>
    <button id="main-menu-hide-button" class="main-menu-hide-button" hidden (click)="onHideMainMenu()">
      <mat-icon class="ointer-events-none">close</mat-icon>
    </button>
  </nav>
</div>
